import { Alert } from "react-native";

const sendTopicAssignmentEmail = async (
  recipientEmail,
  employeeName,
  topicName,
  companyName
) => {
  const emailData = {
    personalizations: [
      {
        to: [{ email: recipientEmail }],
        subject: `New Topic Assigned: ${topicName}`,
      },
    ],
    from: { email: "tanmaygharat957@gmail.com" }, // your verified sender
    content: [
      {
        type: "text/plain",
        value: `Hi ${employeeName},

You have been assigned the topic "${topicName}" by ${companyName}.

Please complete it during this quarter.

Regards,  
The Platform Team`,
      },
    ],
  };

  try {
    const response = await fetch("https://api.sendgrid.com/v3/mail/send", {
      method: "POST",
      headers: {
        Authorization: `Bearer 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`, // replace with your key
        "Content-Type": "application/json",
      },
      body: JSON.stringify(emailData),
    });

    if (!response.ok) {
      const error = await response.json();
      console.error("Email error:", error);
    } else {
      console.log("Assignment email sent!");
    }
  } catch (err) {
    console.error("SendGrid error:", err.message);
  }
};

export default sendTopicAssignmentEmail;
